export const items = [
  {
    id: 1,
    label: '大家說英語',
    value: 'lt',
    path: '/resources/lt',
    children: [
      {
        id: 1,
        value: '1',
        label: '常用資源一鍵下載',
        slug: 'all',
        path: '/resources/lt/all',
      },
      {
        id: 6,
        value: '6',
        label: '1.Text Articles & Translation',
        slug: 'text-articles-translation',
        path: '/resources/lt/text-articles-translation',
      },
      {
        id: 8,
        value: '8',
        label: '2.Language Tip',
        slug: 'language-tip',
        path: '/resources/lt/useful-tips',
      },
      {
        id: 4,
        value: '4',
        label: '3.Key Words',
        slug: 'key-words',
        path: '/resources/lt/key-words',
      },
      {
        id: 9,
        value: '9',
        label: '4.Weekly Tests (+MP3)',
        slug: 'weekly-tests',
        path: '/resources/lt/weekly-tests',
      },
      {
        id: 7,
        value: '7',
        label: '5.Unit Tests',
        slug: 'unit-tests',
        path: '/resources/lt/unit-tests',
      },
      {
        id: 3,
        value: '3',
        label: '6.Key Word List Tests',
        slug: 'key-word-list-tests',
        path: '/resources/lt/key-word-list-tests',
      },
      {
        id: 11,
        value: '11',
        label: '7.每日聽力巻',
        slug: 'daily-listening',
        path: '/resources/lt/daily-listening',
      },
      // {
      //   id: 2,
      //   value: '2',
      //   label: '8.Calendar Phrases (~2025/06)',
      //   slug: 'calendar-phrases',
      //   path: '/resources/lt/calendar-phrases',
      // },
      // {
      //   id: 5,
      //   value: '5',
      //   label: '9.Self-Study Form (~2025/06)',
      //   slug: 'self-study-form',
      //   path: '/resources/lt/self-study-form',
      // },
    ],
  },
  {
    id: 2,
    label: '空中英語教室',
    value: 'sc',
    path: '/resources/sc',
    children: [
      {
        id: 1,
        value: '1',
        label: '常用資源一鍵下載',
        slug: 'all',
        path: '/resources/sc/all',
      },
      {
        id: 6,
        value: '6',
        label: '1.Text Articles & Translation',
        slug: 'text-articles-translation',
        path: '/resources/sc/text-articles-translation',
      },
      {
        id: 9,
        value: '9',
        label: '2.Word Bank',
        slug: 'word-bank',
        path: '/resources/sc/word-bank',
      },
      {
        id: 2,
        value: '2',
        label: '3.Cloze',
        slug: 'cloze',
        path: '/resources/sc/cloze',
      },
      {
        id: 8,
        value: '8',
        label: '4.Weekly Tests (+MP3)',
        slug: 'weekly-tests',
        path: '/resources/sc/weekly-tests',
      },
      {
        id: 7,
        value: '7',
        label: '5.Unit Tests',
        slug: 'unit-tests',
        path: '/resources/sc/unit-tests',
      },
      {
        id: 3,
        value: '3',
        label: '6.Word Power (Grammar Review)',
        slug: 'grammar-review',
        path: '/resources/sc/grammar-review',
      },
      {
        id: 5,
        value: '5',
        label: '7.Teaching Notes',
        slug: 'teaching-notes',
        path: '/resources/sc/teaching-notes',
      },
      {
        id: 4,
        value: '4',
        label: '8.Language Lab',
        slug: 'info-cloud-and-vocabulary',
        path: '/resources/sc/info-cloud-and-vocabulary',
      },
      {
        id: 13,
        value: '13',
        label: '9.素養導向學習單',
        slug: 'steam-learning',
        path: '/resources/sc/steam-learning',
      },
      {
        id: 12,
        value: '12',
        label: '10.Newsworthy',
        slug: 'newsworthy',
        path: '/resources/sc/newsworthy',
      },
      {
        id: 15,
        value: '15',
        label: '11.Deep Dive (2026 起電視節目新單元)',
        slug: 'deep-dive',
        path: '/resources/sc/deep-dive',
      },
      {
        id: 14,
        value: '14',
        label: '12.課文賞析',
        slug: 'other',
        path: '/resources/sc/other',
      },
      // {
      //   id: 11,
      //   value: '11',
      //   label: '12.每日聽力巻(~202012)',
      //   slug: 'daily-listening',
      //   path: '/resources/sc/daily-listening',
      // },
    ],
  },
]
